<template>
  <div id="ProRataModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog upgrade-account-modal">
      <div class="modal-content first-modal-content">
        <div class="modal-header upgradeModal-bgcolor">
          <button type="button" class="close" @click="closePopup" data-target="#UpgradeModal">
            &times;
          </button>
          <div class="modal-title">
            <div class="upgrade-service-para fw-400">Pro Rata Pricing</div>
          </div>
        </div>
        <div class="modal-body confirm-body row m-0">
          <div class="col-sm-12">Please check the details to proceed:</div>
          <div class="border-box col-sm-12">
            <div class="row">
              <div class="col-md-12 d-flex">
                <div class="wd-200">Currently Active Services:</div>
                <div>
                  <ol>
                    <li v-for="(data, index) in proRataData.planInfo" :key="index">
                      <div>{{ data.name }}</div>
                      <div>Expiration Date - {{ data.valid_until | dateFormat }}</div>
                    </li>
                  </ol>
                </div>
              </div>
              <div class="col-md-12"><hr /></div>
            </div>
            <div class="row">
              <div class="col-md-12 d-flex">
                <div class="wd-200">Note:</div>
                <div class="">
                  <ul>
                    <li>As you activate the {{ serviceSelected.name }} Package the current active Services will be canceled and a pro rated amount will be credited towards the purchase price of the Package.</li>
                    <li>The new starting Date of the {{ serviceSelected.name }} Package will be {{ todayDate | dateFormat }}.</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-12"><hr /></div>
            </div>
            <div class="row">
              <div class="col-md-12 d-flex">
                <div class="wd-200">Credit Amount:</div>
                <div class="">${{ proRataData.creditPrice }}</div>
              </div>
              <div class="col-md-12"><hr /></div>
            </div>
            <div class="row">
              <div class="col-md-12 d-flex">
                <div class="wd-200">Package Price:</div>
                <div class="">${{ serviceSelected.price }}</div>
                <!-- <div class="">${{getTotalPrice()}}</div> -->
              </div>
              <div class="col-md-12"><hr /></div>
            </div>
            <div class="row">
              <div class="col-md-12 d-flex">
                <div class="wd-200">Final Price:</div>
                <div v-if="Math.sign(serviceSelected.price - proRataData.creditPrice) === -1">$0 (Credit ${{ Math.abs(serviceSelected.price - proRataData.creditPrice) }}. Please contact <a href="mailto:ramshelp@ul.com">RAMSHelp@ul.com</a> for support)</div>
                <div v-else class="">${{ serviceSelected.price - proRataData.creditPrice }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer cancelModal-bgcolor">
          <div class="col-xs-12 pl-0 text-right">
            <button class="btn emergo-white-button custom-wd-160" @click="closePopup()">
              Cancel
            </button>
            <button class="btn emergo-green-button custom-wd-160" @click="continueUpgrade()">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';

export default {
  props: ['proRataData', 'nextSlide', 'serviceSelected', 'selectedRecords'],

  data() {
    return {};
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('MM/DD/YYYY');
    },
  },
  computed: {
    todayDate() {
      return moment();
    },
  },
  methods: {
    getTotalPrice() {
      if (this.serviceSelected && this.serviceSelected.is_bundle && this.selectedRecords.price) {
        return parseInt(this.serviceSelected.price, 10) + parseInt(this.selectedRecords.price, 10);
      }
      return this.serviceSelected.price || 0;
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    closePopup() {
      $('#ProRataModal').modal('hide');
    },
    continueUpgrade() {
      if (this.proRataData && Math.sign(this.serviceSelected.price - this.proRataData.creditPrice) === -1) {
        this.$router.push('/layout/market-place');
      } else {
        this.$emit('nextSlide');
      }
      this.closePopup();
    },
  },
};
</script>

<style scoped>
.d-flex {
  display: table;
}
.wd-200 {
  width: 200px;
  display: table-cell;
}
.service-header {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  padding-left: 30px;
}
.service-description {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
}
.modal-header .close {
  background: none;
  opacity: 1;
  height: 17px;
  line-height: 17px;
  color: #828282;
  width: 17px;
  border-radius: 20px;
  font-weight: 300;
  outline: none;
  font-size: 32px;
}
.confirm-body {
  padding: 0 24px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
  max-height: 70vh;
  overflow-y: scroll;
}
.modal-content.first-modal-content {
  border-radius: 12px;
}
.modal-footer.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding: 24px;
}
.modal-header.upgradeModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 24px;
}
.upgrade-service-para {
  font-size: 24px;
  line-height: 28px;
  text-align: left;
  color: #0b3c61;
  font-weight: 500;
}
.modal-open .modal {
  overflow-y: hidden;
}
.border-box {
  background: #ffffff;
  border: 1px solid #bdbdbd;
  border-radius: 10px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  padding: 30px;
  margin: 10px 0 30px;
  color: rgba(0, 0, 0, 0.7);
}
.modal-footer .btn + .btn {
  margin-left: 10px;
}
ul li:not(:last-child),
ol li:not(:last-child) {
  padding-bottom: 20px;
}
ul,
ol {
  padding-left: 30px;
}
@media only screen and (max-width: 767px) {
  .please-cancel-btn {
    margin-bottom: 14px;
  }
  .border-box {
    padding: 15px;
  }
  .d-flex {
    display: block;
  }
  .wd-200 {
    width: 100%;
    margin-bottom: 10px;
    display: block;
  }
  .upgrade-service-para {
    font-size: 20px;
  }
}
@media only screen and (min-width: 1024px) {
  .upgrade-account-modal {
    width: 860px;
  }
  .custom-wd-160 {
    width: 160px;
  }
}
@media only screen and (min-width: 768px) {
  .custom-wd-160 {
    width: 160px;
  }
}
</style>
